/**
 * Terms of Use page.
 * Renders DeepThink's Terms of Use content with accessible, readable typography.
 * Update whenever the legal Terms of Use text changes or layout guidelines evolve.
 */
import { Helmet } from 'react-helmet-async';
import { useLocation, useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Button, Container } from '@mui/material';

import TermsOfUseContent from '@/components/enrollment/TermsOfUseContent';

interface LocationState {
  from?: string;
  returnTo?: string;
}

function TermsOfUsePage() {
  const location = useLocation();
  const navigate = useNavigate();
  const state = location?.state as LocationState | null;
  const cameFromPendingApproval = state?.from === 'pending-approval';
  const returnTo = state?.returnTo || '/';
  return (
    <>
      <Helmet>
        <title>Terms of Use | DeepThink</title>
      </Helmet>
      <Container
        className="safe-mobile-all"
        maxWidth="md"
        sx={{ py: { xs: 3, sm: 6 } }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {cameFromPendingApproval && (
            <Box sx={{ mb: 1 }}>
              <Button
                size="small"
                startIcon={<ArrowBackIcon />}
                onClick={() => navigate(returnTo, { replace: true })}
                sx={{ textTransform: 'none', px: 0 }}
              >
                Back to Activation
              </Button>
            </Box>
          )}
          <TermsOfUseContent />
        </Box>
      </Container>
    </>
  );
}

export default TermsOfUsePage;
